'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _Modal = require('./Modal.scss');var _Modal2 = _interopRequireDefault(_Modal);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var DecoratedModal = function DecoratedModal(properties) {
  if (properties.isOpen) {var _cx, _cx2, _cx3;
    var messageModal = void 0;
    var closeBtn =
    _react2.default.createElement('span', { className: (0, _classnames2.default)(_Modal2.default.closeButton, 'modal-close-button'), onClick: properties.onRequestClose },
      _react2.default.createElement('span', { className: (0, _classnames2.default)('icon', properties.className === 'propertyDetailsModal' && properties.isMobile ? 'icon-next' : 'icon-close') }));


    var regularModal =
    _react2.default.createElement(_reactModal2.default, _extends({},
      properties, {
        className: (0, _classnames2.default)(_Modal2.default.customStyles, properties.className, _Modal2.default[properties.className], (_cx = {}, _cx[
        _Modal2.default.propertyModal] = properties.className === 'propertyDetailsModal', _cx[
        _Modal2.default[properties.additionalClassName]] = properties.additionalClassName, _cx)),

        overlayClassName: (0, _classnames2.default)(properties.overlayClassName, (_cx2 = {}, _cx2[
        _Modal2.default.customOverlay] = !properties.plain, _cx2[
        _Modal2.default.darkerOverlay] = properties.className === 'lightboxModal', _cx2[
        _Modal2.default.propertyOverlay] = properties.className === 'propertyDetailsModal', _cx2[
        _Modal2.default.modalHidden] = properties.fadeIn, _cx2[
        _Modal2.default.native] = properties.isNative, _cx2.
        rtl = properties.isRtl, _cx2)),

        contentLabel: properties.contentLabel || 'OnMap Modal',
        onRequestClose: properties.isMobile && properties.className === 'lightboxModal' ? null : properties.onRequestClose }),


      properties.isCloseButtonInvisible || properties.isMobile && properties.className === 'propertyDetailsModal' ? null : closeBtn,

      properties.className === 'advancedFiltersModal' || properties.className === 'contactUsModal' ?
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_Modal2.default.header, (_cx3 = {}, _cx3[_Modal2.default.headerWithoutTitle] = properties.withoutTitle, _cx3)) },
        closeBtn,
        !properties.withoutTitle &&
        _react2.default.createElement('span', { className: _Modal2.default.headerTitle },
          properties.className === 'advancedFiltersModal' ?
          properties.translate('advancedFilters', 'title') :
          properties.translate('contactUsPage', 'title'))) :




      null,

      properties.children);



    if (properties.className === 'messageModal') {var _cx4;
      var childProps = properties.children.props.children.props;
      var isButtonNeeded = childProps && childProps.className && childProps.className.indexOf('successMessage') !== -1;
      messageModal = isButtonNeeded ?
      _react2.default.createElement(_reactModal2.default, _extends({},
        properties, {
          className: (0, _classnames2.default)(
          _Modal2.default.customStyles,
          _Modal2.default.messageModal,
          properties.messageModalClassName, (_cx4 = {

            rtl: properties.isRtl }, _cx4[
          _Modal2.default[properties.additionalClassName]] = properties.additionalClassName, _cx4)),


          overlayClassName: _Modal2.default.customOverlay,
          contentLabel: 'OnMap Modal' }),

        properties.children,
        _react2.default.createElement('a', {
            className: 'btn btn-primary ok-button',
            onClick: properties.onRequestClose },

          properties.translate('publishProperty', 'ok'))) :



      regularModal;

    }

    return (
      _react2.default.createElement('div', null,
        properties.className === 'messageModal' ? messageModal : regularModal));


  }

  return _react2.default.createElement('div', null);
};exports.default =

DecoratedModal;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.js
// module id = 560
// module chunks = 0